'use strict';

var _ = require('lodash');
var WhatIfPopoverController = function WhatIfPopoverController($scope, momentService, constants) {
  var requestStatus = constants.WHAT_IF_STATUS;
  var statusClasses = _.invert({
    'fa-spin fa-spinner system-status-in-progress': requestStatus.PROCESSING,
    'fa-ban system-status-error': requestStatus.ERROR,
    'fa-check system-status-done': requestStatus.FINISHED
  });
  $scope.initScope = function () {
    var now = momentService.now(momentService.FIELD.RULE_EFFECTIVE_DATE).startOf('day');
    $scope.whatIfRange = {
      dateNow: now,
      dateRangeFrom: now.clone(),
      dateRangeTo: now.clone().add(6, 'days')
    };
  };
  $scope.submitButtonEnabled = function () {
    var range = $scope.whatIfRange;
    return !$scope.isSubmitDisabled && range && range.dateRangeFrom && range.dateRangeTo && !isProcessing();
  };
  $scope.submitWhatIfRequest = function () {
    var range = $scope.whatIfRange;
    $scope.$emit('rule-listing:triggerWhatIf', $scope.rule, range.dateRangeFrom, range.dateRangeTo);
  };
  $scope.isButtonReSubmit = function () {
    return $scope.whatIfStatus && ($scope.whatIfStatus.status === requestStatus.FINISHED || $scope.whatIfStatus.status === requestStatus.ERROR);
  };
  $scope.getStatusClass = function () {
    return $scope.whatIfStatus && statusClasses[$scope.whatIfStatus.status] || '';
  };
  function isProcessing() {
    return $scope.whatIfStatus && $scope.whatIfStatus.status === requestStatus.PROCESSING;
  }
  $scope.isFinished = function () {
    return $scope.whatIfStatus && $scope.whatIfStatus.status === requestStatus.FINISHED;
  };
  $scope.goToWhatIfSummaryHandler = function () {
    $scope.$emit('whatif:goToShowWhatIfResults', $scope.whatIfStatus);
  };
};
WhatIfPopoverController.$inject = ['$scope', 'MomentService', 'StrategyConstants'];
module.exports = WhatIfPopoverController;